import { Guid } from '../../store/model/guid';
import { HistoryItem } from '../../store/reducers/currentSequencedFlowPositionReducer';
import { AssertionException } from '../../utils/log';
import { CurrentSection, getItemsInSequence, isCurrentItemLast } from './context/SequencedContentFlowContext';
import { List } from 'immutable';

export function calculateNextItemsId(currentContentItemId: Guid, currentSection: CurrentSection): Guid {
  if (isCurrentItemLast(currentContentItemId, currentSection)) {
    throw AssertionException('Cannot get next item after last.');
  }

  const itemsInSequence = getItemsInSequence(currentSection);
  const currentContentItemIndex = itemsInSequence.findIndex((contentItemId: Guid) =>
    contentItemId ? contentItemId === currentContentItemId : false
  );
  const nextItemId = itemsInSequence.get(currentContentItemIndex + 1);
  if (!nextItemId) {
    throw AssertionException('Next item ID cannot be undefined.');
  }
  return nextItemId;
}

export function calculateHistoryItems(sequencedFlowStructure: List<HistoryItem>, currentHistoryItem: HistoryItem) {
  const getHistoryItems = (sequencedFlowStructure: List<HistoryItem>, currentHistoryItem: HistoryItem) => {
    const indexOfCurrentItem = sequencedFlowStructure.findIndex((historyItem: HistoryItem) => {
      return historyItem === currentHistoryItem;
    });
    if (indexOfCurrentItem === 0) {
      return List<HistoryItem>();
    }
    const previousItems = sequencedFlowStructure
      .filter(
        (value: HistoryItem, index: number) =>
          index <= indexOfCurrentItem && value.sectionId === currentHistoryItem.sectionId
      )
      .toList();
    const previousSectionId = previousItems.first()?.sectionId;
    if (previousSectionId) {
      const sectionHistoryItem = sequencedFlowStructure.find(
        (historyItem: HistoryItem) => historyItem.contentItemId === previousSectionId
      );
      if (!sectionHistoryItem) {
        throw AssertionException('Section history item cannot be undefined.');
      }
      const previousParentItems: List<HistoryItem> = getHistoryItems(sequencedFlowStructure, sectionHistoryItem)
        .concat(previousItems)
        .toList();
      return previousParentItems;
    }
    return previousItems;
  };

  const historyItems = getHistoryItems(sequencedFlowStructure, currentHistoryItem);

  return historyItems.skipLast(1).reverse().toStack();
}
